//pluginTranslations.js

import i18n from "../i18n";
import store from "../store";
import { loadLanguageAsync, loadSingleTranslation } from "../i18n";

export default {
  // The install method is all that needs to exist on the plugin object.
  // It takes the global Vue object as well as user-defined options.
  install(Vue, options) {
    //var that = this;
    Vue.prototype.uniTranslation = function(code, cult) {
      var str = i18n.t(code, cult) + "";

      //============================
      //MARCO DC 16/03/2022

      if (checkTranslation(str)) {
        //console.log(str + " ==> " + checkTranslation(str));
        var index = store.getters.blackList.indexOf(str);
        //console.log(store.getters.isLoadingStr);
        var isLoadingTmp = store.getters.isLoadingStr;
        if (index == -1 && isLoadingTmp.includes("," + str + ",") == false) {
          isLoadingTmp += "," + str + ",";
          store.dispatch("setIsLoadingStr", isLoadingTmp);
          loadSingleTranslation(store.getters.currentLanguage, str).then(() => {
            if (checkTranslation(str)) {
              str = i18n.t(code, cult) + "";
              console.log(
                "%c" + "There is a problem > " + str,
                "background-color: red; color: white"
              );
              store.dispatch("addInBlackList", str);
            }

            isLoadingTmp = store.getters.isLoadingStr;
            isLoadingTmp = (isLoadingTmp + "").replaceAll("," + str + ",", "");
            store.dispatch("setIsLoadingStr", isLoadingTmp);
          });
        }
      }
      //============================

      if (("" + str).includes("€")) {
        str = str.replace("€", store.getters.simboloValuta);
      }

      if (store.getters.bShowTranslationsId == true) {
        if (str != code) {
          return "[" + code + "] " + str;
        } else {
          return "### " + str;
        }
      } else {
        return str;
      }
    };
    function checkTranslation(trs = "") {
      return (
        trs.startsWith("PHE") ||
        trs.startsWith("GF") ||
        trs.startsWith("GO") ||
        trs.startsWith("GC")
      );
    }
    Vue.prototype.uniToolTipTranslation = function(code, cult) {
      if (store.getters.bShowEnglishToolTip == true) {
        var str = i18n.t(code, cult);
        return str;
      } else {
        return "";
      }
    };

    Vue.prototype.formatMoney = function(amount, decimalCount = 2, decimal = ",", thousands = ".") {
      try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

        const negativeSign = amount < 0 ? "-" : "";

        let i = parseInt((amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))).toString();
        let j = i.length > 3 ? i.length % 3 : 0;

        return (
          negativeSign +
          (j ? i.substr(0, j) + thousands : "") +
          i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
          (decimalCount
            ? decimal +
              Math.abs(amount - i)
                .toFixed(decimalCount)
                .slice(2)
            : "")
        );
      } catch (e) {
        console.log(e);
        return amount.toFixed(2);
      }
    };
  }
};
